import { PROSPECT_LIST_HIDDEN_TYPES } from '@catalyst-psa/shared';

import { CustomerListView } from '../customers/CustomerListView.js';

export function ProspectsPage(): JSX.Element {
  return (
    <CustomerListView
      title="Prospects"
      description="Track sales prospects and pipeline accounts."
      scope="prospects"
      hiddenTypeNames={PROSPECT_LIST_HIDDEN_TYPES}
      createLabel="New prospect"
      basePath="/sales/prospects"
    />
  );
}
